import React from "react";
import ReactPlayer from "react-player";
import ImagenValidada from "../ActividadesUtils/RecursosValidados/ImagenValidada";
import VideoValidado from "../ActividadesUtils/RecursosValidados/VideoValidado";

function FlexSlide({ slideData, currentSlide, index }) {
  return (
    <div className="p-1">
      <div className="slide-media">
        {slideData.imagen ? (
          <ImagenValidada
            src={slideData.imagen}
            className="mx-auto block w-full aspect-video object-cover rounded-md border h-[25rem] md:h-[39rem]"
          />
        ) : null}
        {slideData.video ? (
          <div className="video_bg">
            <VideoValidado
              src={slideData.video}
              className="mx-auto block w-full aspect-video object-cover rounded-xl border min-h-[16rem]"
            />
          </div>
        ) : null}
      </div>
      {slideData.texto && (
        <div className="text-gray-700 text-justify text-sm px-1 pt-3 multi-carousel-text-item">
          <span>{slideData.texto}</span>
        </div>
      )}
    </div>
  );
}

export default FlexSlide;
